var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKeyboardArrowDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 7,
    viewBox: "0 0 12 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99999 6.975C5.86665 6.975 5.74165 6.95417 5.62499 6.9125C5.50832 6.87084 5.39999 6.8 5.29999 6.7L0.699988 2.1C0.516654 1.91667 0.424988 1.68334 0.424988 1.4C0.424988 1.11667 0.516654 0.883336 0.699988 0.700003C0.883321 0.51667 1.11665 0.425003 1.39999 0.425003C1.68332 0.425003 1.91665 0.51667 2.09999 0.700003L5.99999 4.6L9.89999 0.700003C10.0833 0.51667 10.3167 0.425003 10.6 0.425003C10.8833 0.425003 11.1167 0.51667 11.3 0.700003C11.4833 0.883336 11.575 1.11667 11.575 1.4C11.575 1.68334 11.4833 1.91667 11.3 2.1L6.69999 6.7C6.59999 6.8 6.49165 6.87084 6.37499 6.9125C6.25832 6.95417 6.13332 6.975 5.99999 6.975Z",
    fill: "#323335"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyboardArrowDown);
export default __webpack_public_path__ + "static/media/keyboard_arrow_down.c19deb78.svg";
export { ForwardRef as ReactComponent };